import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BaseModal from 'components/BaseModal';
import { useStyles } from './styles';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired,
};

export default function DiscountOfferModal({ open, onClose, onActionClick }) {
  const classes = useStyles();

  return (
    <BaseModal
      size="sm"
      open={open}
      content={
        <Box px={2}>
          <div className={classes.icon}>
            <img src="/images/discount-icon.svg" alt="Discount icon" />
          </div>

          <Typography className={classes.primaryColor} variant="h5" gutterBottom={true}>
            <b>
              We got 10% OFF to a <br /> Researcher Monthly Subscription
            </b>
          </Typography>

          <Box my={2}>
            <Typography>
              <b>Benefits you'll get:</b>
            </Typography>
          </Box>

          <Typography>
            <b>Unlimited Scientific Illustrations</b>
          </Typography>
          <Typography>
            <b>Unlimited Creations</b>
          </Typography>
          <Typography>
            <b>Unlimited External File Upload</b>
          </Typography>
          <Typography>
            <b>Unlimited start-from Templates</b>
          </Typography>
          <Typography>
            <b>6 different illustration versions</b>
          </Typography>
          <Typography>
            <b>5 illustration requests per month</b>
          </Typography>
        </Box>
      }
      cancelButton={false}
      actionText="Get the discount"
      onActionClick={onActionClick}
      onClose={onClose}
    />
  );
}

DiscountOfferModal.propTypes = Props;
